import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function WhatsInside() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const volumes = [{
    emoji: '📘',
    color: 'blue',
    title: 'VOLUMEN 1',
    ages: 'Edades 2-6 años',
    titleEs: 'Colorear y Aprender',
    titleEn: 'Coloring & Learning',
    activities: [{
      emoji: '🎨',
      name: 'Colorear Libre',
      description: '22 dibujos divertidos para colorear: soles, mariposas, cohetes, animales y mucho más'
    }, {
      emoji: '🦁',
      name: 'Colorear y Aprender Animales',
      description: '22 animales con su nombre en Español + English: gato, perro, conejo, pájaro y más'
    }]
  }, {
    emoji: '📙',
    color: 'orange',
    title: 'VOLUMEN 2',
    ages: 'Edades 2-6 años',
    titleEs: 'Colorear y Descubrir el Mundo',
    titleEn: 'Coloring & Discovering the World',
    activities: [{
      emoji: '🎨',
      name: 'Colorear Libre',
      description: '22 dibujos más detallados: princesas, superhéroes, dinosaurios, astronautas y mucho más'
    }, {
      emoji: '🦁',
      name: 'Colorear y Aprender Animales',
      description: '22 animales del mundo con nombre y dato curioso en Español + English: león, elefante, pingüino, ballena y más'
    }]
  }];
  const colorClasses = {
    blue: 'from-blue-50 to-blue-100 border-blue-300',
    orange: 'from-orange-50 to-orange-100 border-orange-300'
  };
  return <section ref={ref} className="w-full bg-white py-16 md:py-20" data-id="element-163">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-164">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} className="font-fredoka text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 text-center mb-1" data-id="element-165">
          TODO lo que viene en el libro:
        </motion.h2>
        <p className="font-nunito text-lg sm:text-xl text-gray-500 italic text-center mb-12" data-id="element-166">
          Everything included in the book:
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-167">
          {volumes.map((volume, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          delay: 0.2 * index,
          duration: 0.6
        }} className={`bg-gradient-to-br ${colorClasses[volume.color as keyof typeof colorClasses]} border-2 p-6 sm:p-8 rounded-3xl shadow-lg`} data-id="element-168">
              <div className="text-5xl mb-4" data-id="element-169">{volume.emoji}</div>
              <h3 className="font-fredoka text-2xl font-bold text-gray-900 mb-1" data-id="element-170">
                {volume.title}
              </h3>
              <p className="font-nunito text-sm font-semibold text-gray-700 mb-3" data-id="element-171">
                {volume.ages}
              </p>
              <p className="font-fredoka text-lg font-bold text-gray-800 leading-tight" data-id="element-172">
                {volume.titleEs}
              </p>
              <p className="font-nunito text-base text-gray-600 italic mb-6" data-id="element-173">
                {volume.titleEn}
              </p>

              <ul className="space-y-5" data-id="element-174">
                {volume.activities.map((activity, i) => <li key={i} className="flex items-start gap-3" data-id="element-175">
                    <span className="text-2xl flex-shrink-0" data-id="element-176">
                      {activity.emoji}
                    </span>
                    <div data-id="element-177">
                      <p className="font-fredoka text-base font-bold text-gray-900 mb-1" data-id="element-178">
                        {activity.name}
                      </p>
                      <p className="font-nunito text-sm text-gray-700 leading-relaxed" data-id="element-179">
                        {activity.description}
                      </p>
                    </div>
                  </li>)}
              </ul>
            </motion.div>)}
        </div>
      </div>
    </section>;
}